export default "__VITE_ASSET__2ff90e48__$_?nuxt_component=async&nuxt_component_name=SvgoProduction__"